var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph-2",
    "data-name": "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.31 48.05a1.5 1.5 0 0 0 -1.11 1.8 61.918 61.918 0 0 1 1.65 14.16 60.923 60.923 0 0 1 -60.85 60.85 60.136 60.136 0 0 1 -36.68-12.32 10.068 10.068 0 1 0 -2.03 2.22 63.1 63.1 0 0 0 38.71 13.1 63.919 63.919 0 0 0 62.12-78.69 1.5 1.5 0 0 0 -1.81-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.15 64.01a60.854 60.854 0 0 1 92.72-51.84 8.967 8.967 0 1 0 1.71-2.47 63.854 63.854 0 0 0 -97.43 54.31 63.264 63.264 0 0 0 1.06 11.62 1.489 1.489 0 0 0 1.47 1.23 1.241 1.241 0 0 0 .27-.03 1.5 1.5 0 0 0 1.21-1.74 60.892 60.892 0 0 1 -1.01-11.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 54.1v.9h18v-.9c-.14-12.16-17.86-12.16-18 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.95 32.84c-16.88.17-33.12-10.26-39.33-14.76a4.474 4.474 0 0 0 -5.24 0c-6.21 4.5-22.49 14.89-39.33 14.76a4.535 4.535 0 0 0 -4.58 4.52c.01 23.09 4.63 56.12 44.5 76.3a4.47 4.47 0 0 0 4.06 0c39.87-20.18 44.49-53.21 44.5-76.3a4.554 4.554 0 0 0 -4.58-4.52zm-25.45 45.66a7.5 7.5 0 0 1 -7.5 7.5h-18a7.5 7.5 0 0 1 -7.5-7.5v-16a7.5 7.5 0 0 1 4.5-6.87v-1.55c.18-16.05 23.82-16.05 24 0v1.55a7.5 7.5 0 0 1 4.5 6.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.456 68.778a.968.968 0 0 1 .2-.764 3.228 3.228 0 1 0 -5.31 0 .958.958 0 0 1 .2.757c-.235 1.171-.9 4.519-1.369 6.843a2 2 0 0 0 1.963 2.386h3.72a2 2 0 0 0 1.962-2.392z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.cd34f47cb70d14ed70ae5b1120635873.svg";
export { ForwardRef as ReactComponent };